
export default {
  download: 'להרוד',
}
